export const addSearchTermIntoCookie = (
  lastQueries: string[] | undefined | null,
  searchTerm: string
) => {
  const isEmptySearch = !!searchTerm.replaceAll(/\W/g, "")
  return (isEmptySearch ? [searchTerm] : [])
    .concat(lastQueries?.filter((query) => query !== searchTerm) ?? [])
    .slice(0, 10)
}
